import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "font-bold text-green-600"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ScoutingCompletedNotification',
  props: {
    notification: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_i18n_t = _resolveComponent("i18n-t");
      return _openBlock(), _createBlock(_component_i18n_t, {
        keypath: "scouting_youth_player_completed"
      }, {
        player: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(__props.notification.payload.playerName), 1)]),
        _: 1
      });
    };
  }
});